var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import StoreMessage from '../stores/StoreMessage';
import Message from '../components/message';
import genericResolveProps from './genericResolveAction';
import LoadingFilled from '../icons/loadingFilled';
var store = new StoreMessage();
export var message = function (_a) {
    var key = _a.key, _b = _a.duration, duration = _b === void 0 ? 7000 : _b, _c = _a.type, type = _c === void 0 ? 'success' : _c, _d = _a.position, position = _d === void 0 ? 'topCenter' : _d, _e = _a.closable, closable = _e === void 0 ? false : _e, props = __rest(_a, ["key", "duration", "type", "position", "closable"]);
    var resolveProps = genericResolveProps(__assign({ type: type }, props), Message, 'message');
    store.subscribe(__assign({ key: key, duration: duration, position: position, closable: closable }, resolveProps));
};
var messageLoading = function (_a) {
    var key = _a.key, render = _a.render, _b = _a.duration, duration = _b === void 0 ? 7000 : _b, _c = _a.type, type = _c === void 0 ? 'success' : _c, _d = _a.position, position = _d === void 0 ? 'topCenter' : _d, _e = _a.closable, closable = _e === void 0 ? false : _e, _f = _a.icon, icon = _f === void 0 ? (React.createElement("div", { className: "icon-message" },
        React.createElement(LoadingFilled, null))) : _f, props = __rest(_a, ["key", "render", "duration", "type", "position", "closable", "icon"]);
    return new Promise(function (resolve) {
        var resolveProps = genericResolveProps(__assign({ type: type, icon: icon }, props), Message, 'message');
        store.subscribe(__assign({ key: key, duration: duration, position: position, closable: closable }, resolveProps));
        duration &&
            setTimeout(function () {
                return resolve(key);
                // resolve 300ms before for update element and not show a new
            }, duration - 300);
    });
};
message.loading = messageLoading;
